import React from "react";
import "./Services.css";
import CTAButton from "../CTA/CTAButton";
import GoogleReviews from "../GoogleReview";

const services = [
  {
    title: "Revisão de Contratos Bancários:",
    text: "Revisamos contratos de empréstimos e financiamentos para identificar e eliminar juros abusivos e cobranças indevidas, adequando os contratos às normas legais.",
  },
  {
    title: "Fraudes do PIX",
    text: " Atuamos na defesa de vítimas de golpe no PIX, para recuperar os valores e buscar reparações.",
  },
  {
    title: "Superendividamento",
    text: "Buscamos a renegociação de suas dívidas de forma justa, pela repactuação sem comprometimento da renda de maneira abusiva.",
  },
  {
    title: "Taxas e Tarifas Indevidas",
    text: "Contestamos cobranças abusivas de taxas bancárias e buscamos a restituição dos valores pagos indevidamente. Muitos consumidores pagam tarifas sem saber que podem ser removidas.",
  },
  {
    title: "Cartão de Crédito Consignado (RMC)",
    text: "Revisamos os descontos do salário ou benefício do INSS para cessar cobranças abusivas e recuperar valores pagos de forma irregular.",
  },
  {
    title: "Venda Casada",
    text: "Buscamos o cancelamento e o reembolso de cobranças forçadas de seguros e outros produtos em contratos.",
  },
  {
    title: "Cartão de Crédito Benefício (RCC)",
    text: "Combatemos descontos abusivos no seu benefício ou salário devido a contratos bancários relacionados ao cartão de crédito benefício vinculado ao INSS e de Servidores Públicos.",
  },
  {
    title: "Fraudes em Empréstimos",
    text: "Defendemos consumidores vítimas de fraudes bancárias, com a contratação de empréstimo em seu nome sem sua autorização, para anulação da dívida e reparação de danos.",
  },
  {
    title: "Readequação da Reserva de Margem Consignável",
    text: "Atuamos para ajustar a margem consignável de desconto de valores além do permitido na folha de pagamento ou benefício de Servidores e dos Beneficiários do INSS, e recuperar valores indevidos.",
  },
  {
    title: "Negativação Indevida",
    text: " Solicitamos a exclusão de nome injustamente negativado e buscamos reparação pelos danos morais causados por causa da negativação.",
  },
  {
    title: "Defesa em Execuções Bancárias",
    text: "Atuamos na suspensão de penhoras, renegociação e defesa contra execuções de instituições bancárias.",
  },
];

const Services = () => {
  return (
    <section className="services" id="services">
      <div className="services-content">
        <h1>NOSSOS SERVIÇOS</h1>
        <div className="services-list">
          {services.map((service, index) => (
            <div className="services-item" key={index}>
              <h3>{service.title}</h3>
              <p>{service.text}</p>
            </div>
          ))}
        </div>
        <div className="services-topics">
          <h1>Conte conosco parA:</h1>
          <ul>
            <li className="services-topic">
              Assessoria jurídica completa para ajudá-lo a enfrentar seus
              problemas com os bancos
            </li>
            <li>
              Análise objetiva do processo, de maneira on line, juntamente com o
              cliente para que ele saiba exatamente as estratégias que serão
              tomadas para a solução do seu caso
            </li>
            <li>
              Aplicativo do escritório para acompanhar o seu processo em tempo
              real
            </li>
          </ul>
        </div>
        <GoogleReviews />
        <CTAButton />
      </div>
    </section>
  );
};

export default Services;
